<template>
  <div class="blog-posts-page posts">
    <div
      class="page-header col-12 d-flex justify-content-between align-items-center"
    >
      <div class="page-header-left d-flex align-items-center">
        <h1 class="w-full">Git Commits</h1>
      </div>

      <span
        class="header-right-side d-flex justify-content-center align-items-center"
      >
        <button
          @click.prevent="triggerDeployment()"
          :disabled="loading"
          class="btn btn-primary"
        >
          Vercel Deploy
        </button>
      </span>
    </div>

    <div class="tags-container">
      <table>
        <thead>
          <tr>
            <th>Author</th>
            <th>Date</th>
            <th>SHA</th>
            <th>Message</th>
            <th>Branch</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="commit in commits" :key="commit.sha">
            <td>{{ commit.commit.author.name }}</td>
            <td>{{ formatDate(commit.commit.author.date) }}</td>
            <td>
              <a :href="commit.html_url" target="_blank">{{ commit.sha }}</a>
            </td>
            <td>{{ commit.commit.message }}</td>
            <td>Not available</td>
            <!-- Branch data is not provided in the response -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Reviews",
  data: () => ({
    commits: [],
    loading: true,
    latestCommit: {},
    repoOwner: "arsapoz",
    repoName: "marco-dental",
    teamId: "arsapozs-projects",
    githubToken:
      "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"
  }),
  mounted() {
    this.getLatestCommit();
  },
  methods: {
    formatDate(date) {
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    async getLatestCommit() {
      this.loading = true;
      try {
        const response = await axios.get(
          `https://api.github.com/repos/${this.repoOwner}/${this.repoName}/commits`,
          {
            headers: {
              Authorization: `token ${this.githubToken}`,
              Accept: "application/vnd.github.v3+json",
              "X-GitHub-Api-Version": "2022-11-28"
            }
          }
        );
        this.commits = response.data;
        const latestDeployment = response.data[0];
        console.log(latestDeployment);
        if (latestDeployment) {
          this.latestCommit = {
            sha: latestDeployment.sha, // Adjusted property name for SHA
            ref: "feature/website-v2", // Use a valid branch name here
            commitMessage: latestDeployment.commit.message,
            repoId: latestDeployment.node_id,
            commitAuthorName: latestDeployment.commit.author.name
          };
        }
      } catch (error) {
        console.error("Error fetching latest commit:", error);
      }

      this.loading = false;
    },
    async triggerDeployment() {
      this.loading = true;
      this.error = null;
      this.success = null;

      try {
        // Call your Next.js API route
        const response = await axios.post(
          "https://marcodentaltourism.com/api/trigger-deployment"
        );
        console.log(response.data);
        // Handle success
        alert("Deployment triggered successfully!");
      } catch (error) {
        // Handle error
        alert("Error triggering deployment: " + error.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.blog-posts-page .tags-container {
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 20px;
}

table th,
table td {
  padding: 12px 15px;
  text-align: left;
  vertical-align: middle;
}

table th {
  background-color: #f9fafb;
  color: #333;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

table tbody tr:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}

table td a {
  color: #006266;
  text-decoration: none;
}

table td a:hover {
  text-decoration: underline;
}

table td {
  font-size: 14px;
  color: #555;
}

.page-header {
  margin-bottom: 20px;
}

.page-header-left h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: #111;
}
</style>
